import styled from "@emotion/styled";
import { Button, TextField } from "@mui/material";
import { ChangeEventHandler } from "react";
interface CertInputProps {
	certText: string;
	disableBox: boolean;
	placeholder: string;
	onClickCert: () => void;
	showConfirmBox: boolean;
	onClickConfirm: () => void;
	confirmText: string;
	onChangeCertText: ChangeEventHandler<HTMLInputElement>;
	onChangeConfirmText: ChangeEventHandler<HTMLInputElement>;
	confirmComplete: boolean;
	label?: string;
}

const CertInput = (props: CertInputProps) => {
	const {
		certText,
		placeholder,
		disableBox,
		onClickCert,
		showConfirmBox,
		onClickConfirm,
		confirmText,
		onChangeCertText,
		onChangeConfirmText,
		confirmComplete,
		label,
	} = props;
	return (
		<Box>
			<div className="certBox">
				<TextField
					InputLabelProps={{ shrink: true }}
					label={label}
					fullWidth
					disabled={disableBox}
					value={certText}
					placeholder={placeholder}
					onChange={onChangeCertText}
				/>
				{!confirmComplete && (
					<div className="buttonBox">
						<Button className="btnc" disabled={disableBox} onClick={onClickCert}>
							인증번호 받기
						</Button>
					</div>
				)}
			</div>
			{showConfirmBox && !confirmComplete && (
				<div className="certBox">
					<TextField
						InputLabelProps={{ shrink: true }}
						fullWidth
						onChange={onChangeConfirmText}
						value={confirmText}
					/>
					<div className="buttonBox">
						<Button className="btnc" onClick={onClickConfirm}>
							인증번호 확인
						</Button>
					</div>
				</div>
			)}
		</Box>
	);
};

const Box = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;

	> .certBox {
		display: flex;
		flex-direction: row;

		> .buttonBox {
			flex-basis: 30%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			min-width: 110px;
			margin-left: 20px;

			> button {
				/* width: 100%;
				border-radius: 8px;
				height: 48px;
				line-height: 48px; */
				background: var(--primary);
				color: white;
				/* border: none;
				font-size: 13px;
				font-weight: bold;
				box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,
					rgb(145 158 171 / 12%) 0px 12px 24px 10px; */
			}
		}
		> .certInput {
			height: 48px;
			line-height: 48px;
			align-self: stretch;
			flex-grow: 0;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 10px;
			padding: 12px;
			border-radius: 8px;
			border: solid 1px #afb1b6;
			width: 100%;
			margin-top: 8px;
			box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,
				rgb(145 158 171 / 12%) 0px 12px 24px 10px;
		}
	}
`;

export default CertInput;
